const LinkType = {
    Github: 'github',
    LinkedIn: 'linkedin',
    Youtube: 'youtube',
    Download: 'download',
    Image: 'image',
    Other: 'other'
}

export default LinkType